import isShowMessageSchema from "./isShowMessageSchema";
import { requestParamSchema } from "./requestParamSchema";
export function defineArgs(cgiName) {
  return state => {
    const schema = state.getCgiParamSchema(cgiName);
    return [isShowMessageSchema, {
      ...schema,
      ...requestParamSchema
    }];
  };
}
//# sourceMappingURL=defineArgs.js.map
